import React from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import type { PlayerProfileFormProps } from './types';
import { asNumber, asString, setNumber, setString } from './helpers';

export const BasketballPlayerProfileForm: React.FC<PlayerProfileFormProps> = ({ value, onChange }) => (
  <Box sx={{ display: 'grid', gap: 1.5, gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' } }}>
    <FormControl fullWidth size="small">
      <InputLabel>Позиция</InputLabel>
      <Select
        value={asString(value.position)}
        label="Позиция"
        onChange={(e) => setString(value, 'position', e.target.value, onChange)}
      >
        <MenuItem value="pg">Разыгрывающий</MenuItem>
        <MenuItem value="sg">Атакующий защитник</MenuItem>
        <MenuItem value="sf">Легкий форвард</MenuItem>
        <MenuItem value="pf">Тяжелый форвард</MenuItem>
        <MenuItem value="c">Центровой</MenuItem>
      </Select>
    </FormControl>
    <TextField label="Номер" size="small" value={asNumber(value.number)} onChange={(e) => setNumber(value, 'number', e.target.value, onChange)} />
    <TextField label="Рост (см)" size="small" value={asNumber(value.heightCm)} onChange={(e) => setNumber(value, 'heightCm', e.target.value, onChange)} />
    <TextField label="Вес (кг)" size="small" value={asNumber(value.weightKg)} onChange={(e) => setNumber(value, 'weightKg', e.target.value, onChange)} />
    <TextField label="Размах рук (см)" size="small" value={asNumber(value.wingspanCm)} onChange={(e) => setNumber(value, 'wingspanCm', e.target.value, onChange)} />
  </Box>
);
